module.exports = __webpack_public_path__ + "assets/normal/images/progress-done.eeed4d28.png";